import Create from "./Create";
import Edit from "./Edit";
import List from "./List";

const routes = [
    {
        path: 'employees',
        element: <List />
    },
    {
        path: 'employees/create',
        element: <Create />
    },
    {
        path: 'employees/edit/:id',
        element: <Edit />
    }
]
export default routes;